export default "__VITE_ASSET__99d16a18__"